module.exports = __webpack_public_path__ + "static/img/dire5.87180a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/dire5.jpg
// module id = U58R
// module chunks = 1